import NotificationsRepo from './NotificationsRepo'

const repositories = {
    notifications: NotificationsRepo
}

export const RepositoryFactory = {
    get: name => repositories[name]
}
